function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button';

require('xps-style/core/appbar.css');

var propTypes = {
  classname: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  titleId: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light']),
  navIcon: PropTypes.string,
  navOnClick: PropTypes.func,
  actionItems: PropTypes.func
};
var defaultProps = {
  title: ''
};

var AppBar = function AppBar(_ref) {
  var classname = _ref.classname,
      title = _ref.title,
      titleId = _ref.titleId,
      theme = _ref.theme,
      navIcon = _ref.navIcon,
      navOnClick = _ref.navOnClick,
      actionItems = _ref.actionItems;
  var titleString = _typeof(title) === 'object' ? title.props.title : title;
  var appBarClassname = cx(_defineProperty({
    appbar: true
  }, "appbar-skin--".concat(theme), theme), classname);
  return /*#__PURE__*/React.createElement("div", {
    className: appBarClassname
  }, /*#__PURE__*/React.createElement(Button, {
    className: "appbar__navIcon",
    size: "large",
    kind: "borderless",
    icon: "only",
    iconName: navIcon,
    onClick: navOnClick
  }), typeof title === 'string' ? /*#__PURE__*/React.createElement("div", {
    id: titleId,
    className: "appbar__title font-md fontweight-500"
  }, titleString) : title, /*#__PURE__*/React.createElement("div", {
    className: "appbar__right"
  }, actionItems && actionItems()));
};

AppBar.propTypes = propTypes;
AppBar.defaultProps = defaultProps;
AppBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppBar",
  "props": {
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "classname": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "theme": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "navIcon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "navOnClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "actionItems": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default AppBar;